/*
 * BFCM PDP save label: "Save 25%(-$167.00)".
 * One calculation for the main price, the sticky add-to-cart bar (it mirrors the main price HTML)
 * and the bundle price. Mirrors snippets/sn-bfcm-pdp-save-text.liquid exactly so the
 * server-rendered label and the live variant update print the same string.
 */
(function (root) {
  'use strict';

  if (root.SNBFCMPrice) return;

  var SEPARATORS = {
    amount_with_comma_separator: ['.', ','],
    amount_no_decimals_with_comma_separator: ['.', ','],
    amount_with_apostrophe_separator: ["'", '.'],
    amount_with_space_separator: [' ', ','],
    amount_with_period_and_space_separator: [' ', '.']
  };

  function toCents(value) {
    if (value == null || value === '') return null;
    var n = Number(value);
    if (!isFinite(n)) return null;
    return Math.round(n);
  }

  /* save = compareAt - price; percent = round(save / compareAt * 100); invalid when compareAt <= price. */
  function calc(price, compareAt) {
    var p = toCents(price);
    var c = toCents(compareAt);
    if (p == null || c == null || p < 0 || c <= p) return { valid: false, save: 0, percent: 0 };
    var save = c - p;
    return { valid: true, save: save, percent: Math.round((save * 100) / c) };
  }

  function stripHtml(value) {
    return String(value || '').replace(/<[^>]*>/g, '').trim();
  }

  /* Always two decimals; symbol, position and separators come from the shop money format. */
  function formatAmount(cents, format) {
    format = stripHtml(format != null ? format : root.SNBFCMMoneyFormat);
    var head = '$';
    var suffix = '';
    var token = '';
    var match = format.match(/^([\s\S]*?)\{\{([\s\S]*?)\}\}([\s\S]*)$/);
    if (match) {
      head = match[1];
      token = match[2].trim();
      suffix = match[3];
    }
    var seps = SEPARATORS[token] || [',', '.'];
    var units = String(Math.floor(cents / 100));
    var rest = String(100 + (cents % 100)).slice(1);
    var grouped = units.replace(/\B(?=(\d{3})+(?!\d))/g, seps[0]);
    return head + grouped + seps[1] + rest + suffix;
  }

  function saveText(price, compareAt, format) {
    var r = calc(price, compareAt);
    if (!r.valid) return '';
    return 'Save ' + r.percent + '%(-' + formatAmount(r.save, format) + ')';
  }

  /* Campaign active = G01 runtime reports a phase (pre / formal / cyber / extended). */
  function isActive() {
    var C = root.SNBFCM;
    if (!C || !C.enabled) return false;
    var phase = C.api && typeof C.api.currentPhase === 'function' ? C.api.currentPhase() : null;
    if (phase == null) phase = C.phase;
    return !!phase;
  }

  /*
   * Fill a save chip. legacyText is what the theme would print without the campaign;
   * it is kept on the chip so a live phase change can switch back.
   */
  function renderChip(el, price, compareAt, legacyText) {
    if (!el) return;
    var r = calc(price, compareAt);
    el.setAttribute('data-sn-price', r.valid ? String(toCents(price)) : '');
    el.setAttribute('data-sn-compare', r.valid ? String(toCents(compareAt)) : '');
    if (legacyText != null) el.setAttribute('data-sn-legacy', legacyText);
    if (!r.valid) {
      el.hidden = true;
      return;
    }
    var text = isActive() ? saveText(price, compareAt) : el.getAttribute('data-sn-legacy') || saveText(price, compareAt);
    if (el.textContent !== text) el.textContent = text;
    el.hidden = false;
    el.style.removeProperty('display');
  }

  function refreshAll() {
    if (typeof document === 'undefined') return;
    var chips = document.querySelectorAll('[data-sn-bfcm-save][data-sn-price]');
    for (var i = 0; i < chips.length; i++) {
      var chip = chips[i];
      var price = chip.getAttribute('data-sn-price');
      var compare = chip.getAttribute('data-sn-compare');
      if (chip.hidden || price === '' || compare === '') continue;
      renderChip(chip, price, compare);
    }
  }

  root.SNBFCMPrice = {
    calc: calc,
    formatAmount: formatAmount,
    saveText: saveText,
    isActive: isActive,
    renderChip: renderChip,
    refreshAll: refreshAll
  };

  if (typeof document !== 'undefined') {
    document.addEventListener('sn-bfcm:phase', refreshAll);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refreshAll);
    else refreshAll();
  }
})(typeof window !== 'undefined' ? window : globalThis);
